import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { getCurrentUser } from 'aws-amplify/auth';

export const inverseAuthGuardGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);

  try {
    await getCurrentUser();
    router.navigate(['/events']);
    return false;
  } catch {
    return true;
  }
};
